var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"message-cmp"},[_c('img',{attrs:{"src":"https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/gouxuan.png","alt":"","srcset":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63281d54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Message.vue
// module id = null
// module chunks = 